import React from 'react';
import Image from 'react-bootstrap/Image';
import FacebookIcon from '../images/facebook.png';
import FacebookBigIcon from '../images/facebookbig.png';
import InstagramIcon from '../images/instagram.png';
import InstagramBigIcon from '../images/instagrambig.png';
import YoutubeIcon from '../images/youtube.png';
import YoutubeBigIcon from '../images/youtubebig.png';
import './ArticleLink.scss';
import MovableBlock from '../form/MovableBlock.js';
import TooltipButtons from '../form/TooltipButtons.js';

class ArticleLink extends React.Component {
    render() {
        let linkContent = null;
        switch (this.props.content.title) {
            case 'facebooklogo':
                linkContent = <Image className='social-media-icon-logo' src={FacebookIcon} alt={this.props.content.title} />;
                break;
            case 'facebooklogobig':
                linkContent = <Image className='social-media-icon-logo-big' src={FacebookBigIcon} alt={this.props.content.title} />;
                break;
            case 'instagramlogo':
                linkContent = <Image className='social-media-icon-logo' src={InstagramIcon} alt={this.props.content.title} />;
                break;
            case 'instagramlogobig':
                linkContent = <Image className='social-media-icon-logo-big' src={InstagramBigIcon} alt={this.props.content.title} />;
                break;
            case 'youtubelogo':
                linkContent = <Image className='social-media-icon-logo' src={YoutubeIcon} alt={this.props.content.title} />;
                break;
            case 'youtubelogobig':
                linkContent = <Image className='social-media-icon-logo-big' src={YoutubeBigIcon} alt={this.props.content.title} />;
                break;
            default:
                linkContent = this.props.content.title;
        }
        const linkBefore = this.props.content.before !== undefined ? this.props.content.before + ' ' : null;
        const linkAfter = this.props.content.after !== undefined ? ' ' + this.props.content.after : null;
        const className = this.props.content.position !== undefined && this.props.content.position === 'center' ? 'article-block link-text-center' : 'article-block link-text-left';

        const link = (
            <div className={className}>
                <span>{linkBefore}</span>
                <a className='text-secondary' target='_blank' rel='noreferrer' href={this.props.content.url}>{linkContent}</a>
                <span>{linkAfter}</span>
            </div>
        );

        if (!this.props.loggedIn) {
            return link;
        }

        if (this.props.movingElement !== null) {
            return (
                <MovableBlock
                    movingElement={this.props.movingElement}
                    handleDragging={this.props.handleDragging}
                    submitMove={this.props.submitMove}
                    elementId={this.props.elementId}
                    content={link}
                />
            );
        } else {
            return (
                <TooltipButtons
                    elementEdit={this.props.elementEdit}
                    elementMove={this.props.elementMove}
                    elementDelete={this.props.elementDelete}
                    elementId={this.props.elementId}
                    elementEditKind='link'
                    content={link}
                />
            );
        }
    }
}

export default ArticleLink;
